import { CampoDeFicha } from "@/componentes/personas/CampoDeFicha"
import type { Editor } from "@/componentes/personas/persona"
import { FECHA_MAXIMA, FECHA_MINIMA } from "@/lib/fechas"

/**
 * Quién es y por dónde se le localiza.
 *
 * Son los campos que lleva toda ficha, sea de empleado o de contacto de importador.
 * Lo que depende del tipo está en `VinculoDePersona`.
 */

export const GENEROS = [
  ["", "—"],
  ["M", "Masculino"],
  ["F", "Femenino"],
  ["OTRO", "Otro"],
] as const

export const ESTADOS_CIVILES = [
  ["", "—"],
  ["SOLTERO", "Soltero/a"],
  ["CASADO", "Casado/a"],
  ["DIVORCIADO", "Divorciado/a"],
  ["VIUDO", "Viudo/a"],
  ["CONCUBINATO", "Concubinato"],
] as const

export function DatosDePersona({ valor, poner }: Editor) {
  return (
    <>
      <section>
        <h3 className="rotulo mb-3">Datos personales</h3>
        <div className="grid gap-3 sm:grid-cols-2">
          <CampoDeFicha id="p-nombres" etiqueta="Nombres">
            <input
              id="p-nombres"
              className="campo"
              value={valor("nombres")}
              onChange={(e) => poner("nombres", e.target.value)}
            />
          </CampoDeFicha>
          <CampoDeFicha id="p-apellidos" etiqueta="Apellidos">
            <input
              id="p-apellidos"
              className="campo"
              value={valor("apellidos")}
              onChange={(e) => poner("apellidos", e.target.value)}
            />
          </CampoDeFicha>
          <CampoDeFicha id="p-nacimiento" etiqueta="Fecha de nacimiento">
            <input
              id="p-nacimiento"
              type="date"
              className="campo"
              min={FECHA_MINIMA}
              max={FECHA_MAXIMA}
              value={valor("fecha_nacimiento")}
              onChange={(e) => poner("fecha_nacimiento", e.target.value)}
            />
          </CampoDeFicha>
          <CampoDeFicha id="p-genero" etiqueta="Género">
            <select
              id="p-genero"
              className="campo"
              value={valor("genero")}
              onChange={(e) => poner("genero", e.target.value)}
            >
              {GENEROS.map(([v, t]) => (
                <option key={v} value={v}>
                  {t}
                </option>
              ))}
            </select>
          </CampoDeFicha>
          <CampoDeFicha id="p-civil" etiqueta="Estado civil">
            <select
              id="p-civil"
              className="campo"
              value={valor("estado_civil")}
              onChange={(e) => poner("estado_civil", e.target.value)}
            >
              {ESTADOS_CIVILES.map(([v, t]) => (
                <option key={v} value={v}>
                  {t}
                </option>
              ))}
            </select>
          </CampoDeFicha>
        </div>
      </section>

      <section>
        <h3 className="rotulo mb-3">Contacto</h3>
        <div className="grid gap-3 sm:grid-cols-2">
          <CampoDeFicha id="p-telefono" etiqueta="Teléfono">
            <input
              id="p-telefono"
              className="campo"
              value={valor("telefono")}
              onChange={(e) => poner("telefono", e.target.value)}
            />
          </CampoDeFicha>
          <CampoDeFicha id="p-correo" etiqueta="Correo personal">
            <input
              id="p-correo"
              type="email"
              className="campo"
              value={valor("email_personal")}
              onChange={(e) => poner("email_personal", e.target.value)}
            />
          </CampoDeFicha>
          <div className="sm:col-span-2">
            <CampoDeFicha id="p-direccion" etiqueta="Dirección">
              <textarea
                id="p-direccion"
                rows={2}
                className="campo"
                value={valor("direccion")}
                onChange={(e) => poner("direccion", e.target.value)}
              />
            </CampoDeFicha>
          </div>
          <CampoDeFicha id="p-emergencia" etiqueta="Contacto de emergencia">
            <input
              id="p-emergencia"
              className="campo"
              value={valor("contacto_emergencia")}
              onChange={(e) => poner("contacto_emergencia", e.target.value)}
            />
          </CampoDeFicha>
          <CampoDeFicha id="p-tel-emergencia" etiqueta="Teléfono de emergencia">
            <input
              id="p-tel-emergencia"
              className="campo"
              value={valor("telefono_emergencia")}
              onChange={(e) => poner("telefono_emergencia", e.target.value)}
            />
          </CampoDeFicha>
        </div>
      </section>
    </>
  )
}
